import React, { useState } from 'react';

function DeleteButton({
  label = 'Delete',
  confirmMessage = 'Delete this item? This cannot be undone from the UI.',
  onDelete,
  className = 'btn btn-sm btn-danger',
  disabled = false,
}) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (!window.confirm(confirmMessage)) return;
    setBusy(true);
    try {
      await onDelete();
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      disabled={disabled || busy}
      onClick={handleClick}
    >
      {busy ? 'Deleting…' : label}
    </button>
  );
}

export default DeleteButton;
